import type { ComponentSchema } from '../../../../../schema-types'

/** The header's black bar with these messages; a code shows after its message. The bar keeps the theme colours. */
export const schema: ComponentSchema = {
  type: 'announcement-bar',
  label: 'Announcement bar',
  description: 'A slim rotating bar of short messages, with an optional coupon code after each.',
  supportedPages: ['home', 'shop', 'product', 'category', 'categories', 'cart', 'checkout', 'contact', 'wishlist'],
  variants: [{ id: 'v1', label: 'Rotating bar' }],
  commonFields: [{
    key: 'items',
    label: 'Messages',
    type: 'array',
    itemSchema: [
      { key: 'text', label: 'Message', type: 'string' },
      { key: 'code', label: 'Coupon code (optional)', type: 'string' },
    ],
    default: [{ text: 'Free delivery on orders over 1000' }],
  }],
}
